import { render, staticRenderFns } from "./section.vue?vue&type=template&id=20fda73a&scoped=true"
import script from "./section.vue?vue&type=script&lang=js"
export * from "./section.vue?vue&type=script&lang=js"
import style0 from "./section.vue?vue&type=style&index=0&id=20fda73a&prod&scoped=scoped&lang=css"
import style1 from "./section.vue?vue&type=style&index=1&id=20fda73a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fda73a",
  null
  
)

export default component.exports